



















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class KasusKronis extends Vue {
  @Prop() setKronis: string;
  // kronis = false;

  // @Watch("kronis")
  // changeKronis(val) {
  //   this.$emit("kronis", val);
  // }
  @Watch("setKronis")
  changeSetKronis(val) {
    // this.kronis = val;
    this.$emit("kronis", val);
  }
}
